import script from "./HomeBoardListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeBoardListItem.vue?vue&type=script&setup=true&lang=ts"

import "./HomeBoardListItem.vue?vue&type=style&index=0&id=437c75ff&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-437c75ff"]])

export default __exports__